module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "timeline-item"
  }, [_c('div', {
    staticClass: "timeline-badge",
    class: _vm.item.icon_status
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.item.icon_class
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', {
    staticClass: "timeline-title"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel-controls"
  }, [_c('div', {
    staticClass: "controls"
  }, _vm._l((_vm.item.controls), function(control) {
    return _c('time-line-control', {
      key: control,
      attrs: {
        "control": control
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "timestamp"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n            " + _vm._s(_vm._f("moment")(_vm.item.updated, 'D/MM/Y HH:mm')) + " (" + _vm._s(_vm._f("moment")(_vm.item.updated, 'from', 'now')) + ")\n          ")])])])]), _vm._v(" "), (_vm.item.dataJSON) ? _c('div', {
    staticClass: "l-row code-container"
  }, [_c('div', {
    staticClass: "l-col-10@md data-json"
  }, [_c('vue-json-pretty', {
    attrs: {
      "data": _vm.item.dataJSON,
      "deep": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md u-textRight"
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (JSON.stringify(_vm.item.dataJSON)),
      expression: "JSON.stringify(item.dataJSON)",
      arg: "copy"
    }],
    staticClass: "btn btn--success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "timeline-body",
    domProps: {
      "innerHTML": _vm._s(_vm.item.body)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f62b4024","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/timeLine/Item.vue
// module id = 3497
// module chunks = 0